import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import {
	FlatRowSelect,
	type FlatRowSelectOption,
} from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

type Props<
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number,
> = {
	control: Control<FormType>;
	name: TName;
	label: string;
	options: FlatRowSelectOption<TValue>[];
	drawerTitle?: string;
	isLast?: boolean;
};

export const FlatRowFormSelect = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TValue extends string | number = string,
>({
	control,
	name,
	label,
	options,
	drawerTitle,
	isLast,
}: Props<FormType, TName, TValue>) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { value, onChange, onBlur },
				fieldState: { error },
			}) => (
				<FlatRowSelect<TValue>
					label={label}
					value={(value ?? "") as TValue | ""}
					options={options}
					onChange={onChange}
					onBlur={onBlur}
					drawerTitle={drawerTitle}
					isLast={isLast}
					error={!!error?.message}
					helperText={error?.message}
				/>
			)}
		/>
	);
};
